import {RefObject, useRef, useState } from "react";
import {lessonPreviewPlay} from "../../../../../services/songs/lessonPreviewPlay";
import {LessonPreviewType} from "../../../../../client/models/songs/LessonPreviewType";

export interface IArrangementPreviewButtonLogic {
  audioRef: RefObject<HTMLAudioElement>,
  isPreviewPlaying: boolean,
  toggleAudio: () => void,
  resetAudioPreview: () => void,
}

export const useArrangementPreviewButtonLogic = (lessonId: number, previewType: LessonPreviewType): IArrangementPreviewButtonLogic => {
  const audioRef = useRef<HTMLAudioElement>(document.createElement('audio'));
  const [isPreviewPlaying, setPreviewPlaybackState] = useState<boolean>(false);
  const toggleAudio = () => {
    if (audioRef.current.paused) {
      // record every Play press, including resuming after a pause; pause presses are not recorded
      lessonPreviewPlay.record(lessonId, previewType, audioRef.current.currentTime);
      audioRef.current.play();
      setPreviewPlaybackState(true);
    } else {
      audioRef.current.pause();
      setPreviewPlaybackState(false);
    }
  }

  const resetAudioPreview = () => {
    setPreviewPlaybackState(false);
  }

  return {audioRef, isPreviewPlaying, toggleAudio, resetAudioPreview};
}
